<template>
  <transition appear name="fade">
    <div v-show="show" class="portfolio-item col-lg-4 col-sm-6 mb-4">
      <div class="portfolio-link">
        <div class="portfolio-hover">
          <div class="portfolio-hover-content">
            <!-- <a href="" title="Click to start listening" class="mr-4" @click.prevent="playThisShow(show)"><i class="fas fa-headphones fa-4x"></i></a> -->
            <router-link title="Click for tracklist" data-toggle="modal" :to="{ name: 'show', params: { showId: show.id } }"><i class="fas fa-list-ol fa-4x"></i></router-link>
          </div>
        </div>
        <img v-if="show.image" class="img-fluid" :src="show.image" />
        <img v-if="!show.image" class="img-fluid" src="../assets/placeholder.png" />
      </div>
      <div class="portfolio-caption">
        <div class="portfolio-caption-heading">{{show.title}}</div>
        <div class="portfolio-caption-subheading text-muted">
          <span :title="printDateTime(show.dateTimeBroadcast)">{{ printTime(show.date_on_air) }}</span>
          by {{show.djs}}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from "moment";

export default {
  name: "showTeaser",
  props: ["show"],
  data: function () {
    return {};
  },
  methods: {
    printTime: function (timeOfBroadcast) {
      return moment(timeOfBroadcast, "YYYY-MM-DD").fromNow();
    },
    printDateTime: function (datetime) {
      return moment(datetime).format("MMMM Do YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
#portfolio .portfolio-item .portfolio-link .portfolio-hover {
  background: rgba(33,37,41,.6);
}

.touch #portfolio .portfolio-item .portfolio-link .portfolio-hover {
  opacity: 1 !important;
}

.portfolio-hover-content a {
  color: #e35313;
}

</style>
